import { getEnecoBeXapiSiteApiV1OrdersByOrderId } from '@eneco/dc-be/client/services.gen.js';
import usePublicDCBE from '@eneco/dc-be/hooks/usePublicDCBE.js';
import unwrapData from '@eneco/dc-be/utils/unwrapData.js';
import { useRouter } from 'next/router';

import { loadOrderManagementState } from '../utils/orderManagementStorage';

export const useOrderId = (): string | undefined => {
  const { query } = useRouter();
  const fromQuery = query.orderId as string | undefined;
  const fromStorage = loadOrderManagementState().orderId;

  const orderId = fromQuery || fromStorage;

  // check if the orderId exists
  const { data: orderDataRaw } = usePublicDCBE(
    getEnecoBeXapiSiteApiV1OrdersByOrderId,
    { path: { orderId: orderId ?? '' } },
    [`/orders/${orderId}`],
    !!orderId,
    undefined,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );
  const orderData = unwrapData(orderDataRaw);

  return orderData?.orderId;
};
